import React from "react";
import ReactDOM from "react-dom/";
import App from "./App";

import { BrowserRouter } from "react-router-dom";
import GlobalStyle from "./style/globalstyle";
import Providers from "./Providers"

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <GlobalStyle />
      <Providers>
        <App />
      </Providers>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
